import { imageUrl } from '@helpers/image';
import { ButtonType } from '@stories/Components/Buttons/Button/ButtonType';
import FakeButton from '@stories/Components/Buttons/FakeButton/FakeButton';
import * as React from 'react';
import S from './OurPeopleCard.styles';
const OurPeopleCard = (props) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.ItemInner, { ...(props.cta ? {
                as: 'a',
                href: props.cta.url,
                target: props.cta.target ?? '_self',
                'aria-label': props.cta.text,
            } : {}) },
            React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { alt: props.image.altText, loading: "lazy", role: props.image.altText ? undefined : 'presentation', src: imageUrl(props.image, { width: 304, height: 304 }), srcSet: [
                        `${imageUrl(props.image, { width: 144, height: 144 })} 320w`,
                        `${imageUrl(props.image, { width: 220, height: 220 })} 480w`,
                        `${imageUrl(props.image, { width: 304, height: 304 })} 767w`,
                    ].join(','), width: "304", height: "304" })),
            React.createElement(S.ItemName, null, props.name),
            React.createElement(S.ItemJobTitle, null, props.jobTitle),
            props.cta &&
                React.createElement(S.CtaWrapper, null,
                    React.createElement(FakeButton, { buttonType: ButtonType.ThinOutline }, props.cta.text)))));
};
export default OurPeopleCard;
